// interface
interface Route {
    key: string,
    title: string,
    path: string,
    enabled: boolean
}

export const routes: Array<Route> = [
    {
        key: 'kolding-route',
        title: 'Kolding',
        path: '',
        enabled: true
    },
]